import React from 'react';

import { IChallengePageProps } from './interfaces';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';

import { st, classes } from './Widget.st.css';
import { UserState } from '../../../contexts/User/UserContext';
import settingsParams from '../settingsParams';
import { IChallengeSettings } from '../Settings/challengeSettings/challengeSettings.types';
import { withProviders } from '../../../contexts/main/withProviders';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { FCWithChildren } from '@wix/challenges-web-library';

const VisitorPage = loadable(() => {
  return import(
    /* webpackChunkName: "ProgramsVisitorPage" */ './views/VisitorPage/VisitorPage'
  );
});

export const ChallengePage: FCWithChildren<IChallengePageProps> = (props) => {
  const { t } = useTranslation();
  const { isViewer, isMobile, language } = useEnvironment();

  const settings = useSettings();
  const pageRef = React.useRef<HTMLDivElement>();

  const settingsProp: IChallengeSettings = {} as any;
  Object.keys(settingsParams).map((key) => {
    settingsProp[key] = settings.get(settingsParams[key]);
  });

  const { userType, challengeData } = props;

  React.useEffect(() => {
    props.hideLoader && props.hideLoader();
  }, []);
  if (props.isForcedBlankPage) {
    return null;
  } else if (!challengeData?.challenge && isViewer) {
    if (userType === UserState.VISITOR) {
      props.promptLogin();
    }

    return <p className={classes.noAccess}>{t('challenge.no-access')}</p>;
  }
  return (
    <div
      ref={pageRef}
      data-hook="program-page-main"
      className={st(classes.root)}
    >
      <div data-hook="challenge-page">
        <VisitorPage
          t={t}
          lng={language}
          {...props}
          settings={settingsProp as any}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

ChallengePage.displayName = 'ChallengePageContainer';

export default withProviders(ChallengePage);
